import React, { FC, useMemo, memo } from 'react';
import _map from 'lodash/map';
import _pick from 'lodash/pick';
import FormikSelectableSearchDropdown from '@minecraft.formik-selectable-search-dropdown';
import { appConfig, modifiedTileSchemaValueEnum as TILE_SCHEME_VALUE } from '@minecraft.app-config';
import { FilterData } from '../../shared/types';
import { Label, StyledFormikSelectableSearchDropdown } from '../../shared/styles';

const TILE_SCHEME = _pick(TILE_SCHEME_VALUE, appConfig.enumTagKeysToShow);

type Props = FilterData;

const SelectionTag: FC<Props> = ({ name, label }) => {
  const tags = useMemo(() => Object.keys(TILE_SCHEME), []);

  return (
    <>
      <Label>{label}</Label>
      <StyledFormikSelectableSearchDropdown saveAsOption name={name}>
        {_map(tags, (tag) => (
          <FormikSelectableSearchDropdown.Option key={tag} label={TILE_SCHEME[tag]} value={TILE_SCHEME[tag]} />
        ))}
      </StyledFormikSelectableSearchDropdown>
    </>
  );
};

export default memo(SelectionTag);
